import { useQuery } from '@tanstack/react-query';
import { supabasePublic } from '@/integrations/supabase/publicClient';
import { TableWeekdayAvailability } from '@/types/table';

export function weekdayAvailabilitiesQueryKey(establishmentId: string | null) {
  return ['weekday-availabilities', establishmentId] as const;
}

export function useWeekdayAvailabilitiesQuery(establishmentId: string | null) {
  return useQuery({
    queryKey: weekdayAvailabilitiesQueryKey(establishmentId),
    queryFn: async (): Promise<TableWeekdayAvailability[]> => {
      let query = supabasePublic.from('table_weekday_availability').select('*');
      if (establishmentId) query = query.eq('establishment_id', establishmentId);

      const { data, error } = await query;
      if (error) throw error;

      return (data || []).map((w: any) => ({
        id: w.id,
        tableId: w.table_id,
        availableDays: w.available_days,
        reason: w.reason || undefined,
        createdAt: new Date(w.created_at),
      }));
    },
    enabled: Boolean(establishmentId),
    staleTime: 1000 * 60 * 5,
  });
}
